(() => {
  if (window.LmcdIllustratingBible) return;
  const mount = root => {
    if (!root || root.dataset.illustratingReady === 'true') return;
    root.dataset.illustratingReady = 'true';
    const cleanup = [];
    const listen = (target, event, handler, options) => {
      target.addEventListener(event, handler, options);
      cleanup.push(() => target.removeEventListener(event, handler, options));
    };
    const faqs = [...root.querySelectorAll('[data-illustrating-faq]')];
    faqs.forEach(faq => listen(faq.querySelector('summary'), 'click', () => {
      if (!faq.open) faqs.forEach(other => { if (other !== faq) other.open = false; });
    }));
    root.querySelectorAll('[data-ib-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-ib-track]');
      const move = direction => {
        const item = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const step = item.getBoundingClientRect().width + gap;
        const current = track.scrollLeft;
        const maximum = track.scrollWidth - track.clientWidth;
        let target = current + direction * step;
        // Recycle existing cards at either edge, preserving a full viewport and
        // every source slide without cloned media or a finite last page.
        if (direction < 0 && current < step - 1) {
          track.style.scrollSnapType = 'none';
          track.prepend(track.lastElementChild);
          track.scrollTo({left: current + step, behavior: 'instant'});
          target = current;
        } else if (direction > 0 && target > maximum + 1) {
          track.style.scrollSnapType = 'none';
          track.append(track.firstElementChild);
          track.scrollTo({left: Math.max(0, current - step), behavior: 'instant'});
          target = current;
        }
        track.style.removeProperty('scroll-snap-type');
        track.scrollTo({left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      listen(carousel.querySelector('[data-ib-prev]'), 'click', () => move(-1));
      listen(carousel.querySelector('[data-ib-next]'), 'click', () => move(1));
    });
    const reviewTrack = root.querySelector('.ib-review-track');
    let reviewDrag;
    const clearReviewDrag = () => {
      if (reviewDrag && reviewTrack.hasPointerCapture(reviewDrag.id)) reviewTrack.releasePointerCapture(reviewDrag.id);
      reviewDrag = null;
      reviewTrack.style.removeProperty('scroll-snap-type');
    };
    listen(reviewTrack, 'pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      event.preventDefault();
      reviewDrag = {id:event.pointerId, x:event.clientX, scroll:reviewTrack.scrollLeft};
      reviewTrack.setPointerCapture(event.pointerId);
      reviewTrack.style.scrollSnapType = 'none';
    });
    listen(reviewTrack, 'pointermove', event => {
      if (reviewDrag?.id === event.pointerId) reviewTrack.scrollLeft = reviewDrag.scroll + reviewDrag.x - event.clientX;
    });
    listen(reviewTrack, 'pointerup', event => {
      if (reviewDrag?.id !== event.pointerId) return;
      const delta = reviewDrag.x - event.clientX;
      const step = reviewTrack.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(reviewTrack).gap) || 0);
      const target = reviewDrag.scroll + (Math.abs(delta) > 40 ? Math.sign(delta) * step : 0);
      clearReviewDrag();
      reviewTrack.scrollTo({left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
    listen(reviewTrack, 'pointercancel', clearReviewDrag);
    cleanup.push(clearReviewDrag);
    const finalSubmit = root.querySelector('[data-illustrating-final-submit]');
    const form = root.querySelector('[data-lmcd-house-primary-form]');
    if (finalSubmit && form) listen(finalSubmit, 'click', () => form.requestSubmit());
    const proof = root.querySelector('.ib-proof-track');
    let animation;
    if (proof && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const keyframes = () => {
        const distance = (proof.scrollWidth + (parseFloat(getComputedStyle(proof).gap) || 0)) / 3;
        return [{transform:'translateX(0)'},{transform:`translateX(-${distance}px)`}];
      };
      animation = proof.animate(keyframes(), {duration:40000,iterations:Infinity});
      const resizeObserver = new ResizeObserver(() => animation.effect.setKeyframes(keyframes()));
      resizeObserver.observe(proof);
      cleanup.push(() => resizeObserver.disconnect());
      listen(proof, 'pointerenter', () => animation.pause());
      listen(proof, 'pointerleave', () => animation.play());
    }
    root.__illustratingTeardown = () => {
      cleanup.splice(0).forEach(remove => remove());
      animation?.cancel();
      delete root.dataset.illustratingReady;
    };
  };
  const mountAll = () => document.querySelectorAll('[data-illustrating-bible-offer]').forEach(mount);
  window.LmcdIllustratingBible = {mount};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, {once:true});
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-illustrating-bible-offer]')) event.target.__illustratingTeardown?.();
    event.target.querySelectorAll?.('[data-illustrating-bible-offer]').forEach(root => root.__illustratingTeardown?.());
  });
})();
